import React, { useState, useEffect } from 'react';

const EntityBlockSlot = ({ entityId, onSuccess, onCancel }) => {
  const [entityConfig, setEntityConfig] = useState(null);
  const [blockedSlots, setBlockedSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  
  const [formData, setFormData] = useState({
    block_date: '',
    reserved_part: '',
    start_time: '',
    end_time: '',
    reason: ''
  });

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([
        fetchEntityConfig(),
        fetchBlockedSlots()
      ]);
      setLoading(false);
    };
    
    if (entityId) {
      fetchData();
    }
  }, [entityId]);

  const fetchEntityConfig = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/EntityPublic/${entityId}/config`
      );
      
      if (response.ok) {
        const config = await response.json();
        setEntityConfig(config);
        console.log('Entity config loaded:', config);
      }
    } catch (err) {
      console.error('Error fetching entity config:', err);
    }
  };

const fetchBlockedSlots = async () => {
  try {
    const token = localStorage.getItem('EntityTokenA');
    // Get current month's date range
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().split('T')[0];
    
    const response = await fetch(
      `${process.env.REACT_APP_API_BASE_URL}/api/appointments/blocked-slots?startDate=${firstDay}&endDate=${lastDay}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    
    if (response.ok) {
      const data = await response.json();
      console.log('Blocked slots loaded:', data); 
      setBlockedSlots(data);
    } else {
      console.error('Failed to fetch blocked slots:', response.status);
    }
  } catch (err) {
    console.error('Error fetching blocked slots:', err);
  }
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const calculateEndTime = (startTime, duration) => {
    const [hours, minutes] = startTime.split(':').map(Number);
    const totalMinutes = hours * 60 + minutes + duration;
    const endHours = Math.floor(totalMinutes / 60) % 24;
    const endMinutes = totalMinutes % 60;
    return `${String(endHours).padStart(2, '0')}:${String(endMinutes).padStart(2, '0')}`;
  };

  const handlePeriodSelect = (period) => {
    setFormData(prev => ({
      ...prev,
      start_time: period.startTime,
      end_time: period.endTime
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!formData.block_date || !formData.reserved_part || !formData.start_time || !formData.end_time) {
      setError('يرجى تعبئة جميع الحقول المطلوبة');
      return;
    }
    
    setSubmitting(true);
    
    try {
      const token = localStorage.getItem('EntityTokenA');
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/appointments/blocked-slots`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(formData)
        }
      );
      
      const data = await response.json();
      
      if (response.ok) {
        // Reset form
        setFormData({
          block_date: '',
          reserved_part: '',
          start_time: '',
          end_time: '',
          reason: ''
        });
        setShowForm(false);
        
        // Refresh blocked slots list
        await fetchBlockedSlots();
        
        if (onSuccess) {
          onSuccess(data);
        }
      } else {
        setError(data.message || 'حدث خطأ في حجز الفترة');
      }
    } catch (err) {
      console.error('Error blocking slot:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setSubmitting(false);
    }
  };


  const handleDeleteBlock = async (blockId) => {
    if (!window.confirm('هل أنت متأدد من إلغاء هذا الحجز؟')) {
      return;
    }
    
    try {
      const token = localStorage.getItem('EntityTokenA');
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/appointments/blocked-slots/${blockId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      if (response.ok) {
        await fetchBlockedSlots();
      } else {
        const data = await response.json();
        alert(data.message || 'حدث خطأ في إلغاء الحجز');
      }
    } catch (err) {
      console.error('Error deleting blocked slot:', err);
      alert('حدث خطأ في الاتصال بالخادم');
    }
  };



  if (loading) {
    return (
      <div className="flex-center p-8">
        <div className="spinner"></div>
        <p className="text-white mt-4">جاري التحميل...</p>
      </div>
    );
  }

  if (!entityConfig) {
    return (
      <div className="bg-red-500 bg-opacity-20 border border-red-500 rounded-lg p-4">
        <p className="text-white">فشل في تحميل بيانات الجهة</p>
      </div>
    );
  }

  return (
    <div className="entity-block-slot">
      <div className="flex-between mb-6">
        <h2 className="text-white text-2xl font-bold">
          حجز فترة محلياً
        </h2>
        <button
          onClick={() => setShowForm(!showForm)}
          className="btn btn-primary"
        >
          {showForm ? 'إخفاء النموذج' : '+ حجز فترة جديدة'}
        </button>
      </div>

      {showForm && (
        <div className="glass p-6 mb-6">
          <h3 className="text-white text-xl font-bold mb-4">حجز فترة جديدة</h3>
          <form onSubmit={handleSubmit} className="flex-column gap-4">
            {/* Date */}
            <div>
              <label className="text-white block mb-2">التاريخ</label>
              <input
                type="date"
                name="block_date"
                value={formData.block_date}
                onChange={handleInputChange}
                min={new Date().toISOString().split('T')[0]}
                className="input"
                required
              />
            </div>

            {/* Part */}
            <div>
              <label className="text-white block mb-2">
                {entityConfig.acceptMultipleUnit === 'yes' ? 'الملعب / الجزء' : 'القاعة / الجزء'}
              </label>
              <select
                name="reserved_part"
                value={formData.reserved_part}
                onChange={handleInputChange}
                className="input"
                required
              >
                <option value="">اختر...</option>
                {entityConfig.parts && entityConfig.parts.map((part, index) => (
                  <option key={index} value={part}>{part}</option>
                ))}
              </select>
            </div>

            {/* Time Selection */}
            {entityConfig.acceptMultipleUnit === 'yes' ? (
              // Multiple unit - select start time and duration
              <>
                <div>
                  <label className="text-white block mb-2">وقت البداية</label>
                  <select
                    name="start_time"
                    value={formData.start_time}
                    onChange={handleInputChange}
                    className="input"
                    required
                  >
                    <option value="">اختر الوقت...</option>
                    {entityConfig.timeSlots && entityConfig.timeSlots.map((slot, index) => (
                      <option key={index} value={slot}>{slot}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="text-white block mb-2">وقت النهاية</label>
                  <select
                    name="end_time"
                    value={formData.end_time}
                    onChange={handleInputChange}
                    className="input"
                    required
                  >
                    <option value="">اختر الوقت...</option>
                    {entityConfig.timeSlots && entityConfig.timeSlots
                      .filter(slot => !formData.start_time || slot > formData.start_time)
                      .map((slot, index) => (
                        <option key={index} value={slot}>{slot}</option>
                      ))}
                  </select>
                </div>
              </>
            ) : (
              // Single period - select from predefined periods
              <div>
                <label className="text-white block mb-2">الفترة</label>
                <div className="flex-column gap-2">
                  {entityConfig.periodSlots && entityConfig.periodSlots.map((period, index) => (
                    <button
                      key={index}
                      type="button"
                      onClick={() => handlePeriodSelect(period)}
                      className={`btn ${
                        formData.start_time === period.startTime
                          ? 'btn-primary'
                          : 'btn-secondary'
                      }`}
                    >
                      {period.label}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Reason */}
            <div>
              <label className="text-white block mb-2">السبب</label>
              <textarea
                name="reason"
                value={formData.reason}
                onChange={handleInputChange}
                className="input"
                rows="2"
                placeholder="سبب الحجز..."
              />
            </div>

            {error && (
              <div className="bg-red-500 bg-opacity-20 border border-red-500 rounded-lg p-3">
                <p className="text-white text-sm">{error}</p>
              </div>
            )}

            <div className="flex gap-4">
              <button
                type="submit"
                className="btn btn-primary flex-1"
                disabled={submitting}
              >
                {submitting ? 'جاري الحجز...' : 'تأكيد الحجز'}
              </button>
              <button
                type="button"
                onClick={() => setShowForm(false)}
                className="btn btn-secondary"
              >
                إلغاء
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Blocked Slots List */}
      <div className="glass p-6">
        <h3 className="text-white text-xl font-bold mb-4">
          الفترات المحجوزة ({blockedSlots.length})
        </h3>
        
        {blockedSlots.length === 0 ? (
          <p className="text-white opacity-70">لا توجد فترات محجوزة</p>
        ) : (
          <div className="flex-column gap-3">
            {blockedSlots.map((slot) => (

        (!slot.isException  &&
              <div key={slot.id} className="glass-dark p-4 rounded-lg">
                <div className="flex-between">
                  <div className="text-white">
                    <p className="font-bold">{slot.reserved_part}</p>
                    <p className="text-sm opacity-80">
                      📅 {slot.date} | 🕐 {slot.times}
                       {/* - {slot.end_time} */}
                    </p>
                    {slot.reason && (
                      <p className="text-sm opacity-70 mt-1">💬 {slot.reason}</p>
                    )}
                  </div>
                  <button
                    onClick={() => handleDeleteBlock(slot.id)}
                    className="btn btn-secondary"
                    style={{ padding: '8px 16px' }}
                  >
                    إلغاء
                  </button>
                </div>
              </div>
             )
            
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EntityBlockSlot;